import { render, staticRenderFns } from "./OrdersV2.vue?vue&type=template&id=507451f6&"
import script from "./OrdersV2.vue?vue&type=script&lang=ts&"
export * from "./OrdersV2.vue?vue&type=script&lang=ts&"
import style0 from "./OrdersV2.vue?vue&type=style&index=0&id=507451f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports